import { createFileRoute } from "@tanstack/react-router";
import { RouteDetailPage } from "~/pages/routes/RouteDetailPage";
export const Route = createFileRoute("/_authenticated/routes/$routeId")({ component: RouteDetailPage });
